import { createApp } from 'vue';
import LocaleSwitcher from './LocaleSwitcher.vue';
import { i18n } from '../../i18n';

const localeSwitcherElement = document.getElementById('locale-switcher');

if (localeSwitcherElement) {
  const app = createApp(LocaleSwitcher);
  app.use(i18n);
  app.mount('#locale-switcher');
}
